import { trpc } from "lib/trpc";

/**
 * PRTL-1360: is the running bundle stale? The web bundle and the API server
 * ship in the same Docker image, so a build-SHA mismatch means a deploy has
 * happened since this tab loaded. Disabled in local dev (no VITE_BUILD_SHA).
 */
export function useAppUpdate(): { updateAvailable: boolean } {
    const currentSha = import.meta.env.VITE_BUILD_SHA;
    const { data } = trpc.config.version.useQuery(undefined, {
        enabled: Boolean(currentSha),
        staleTime: 60_000,
        refetchOnWindowFocus: true,
        refetchInterval: 5 * 60_000,
    });
    const updateAvailable = Boolean(currentSha && data?.buildSha && data.buildSha !== currentSha);
    return { updateAvailable };
}
